module.exports = __webpack_public_path__ + "static/media/ic_apple_icon.1884f2f8.png";